import React from 'react';
import { MdLanguage, MdLocationOn, MdEmail, MdHandshake } from 'react-icons/md';

// 1. KUINGIZA LOGO KAMA VARIABLES KABISA (KAMA ULIVYOELEKEZA)
import lolutechLogo from '../assets/lolutech.png';
import josekoLogo from '../assets/joseko.jpg';
import genemmaLogo from '../assets/genemma.jpg';
import tripplejLogo from '../assets/tripplej.png';
import uniqueLogo from '../assets/unique.jpg';
import techoneLogo from '../assets/techone.png';
import superzamoLogo from '../assets/superzamo.jpg';
import leshaLogo from '../assets/lesha.jpg'

export default function Sponsors() {
  // Array ya data za wadhamini kulingana na maelekezo ya mteja
  const sponsorList = [
    {
      name: "Lolutech Limited",
      location: "Ubungo Plaza, Dar es Salaam",
      contact: "info@lolutech.com",
      logo: lolutechLogo,
      hasEmail: true
    },
    {
      name: "Joseko Building Materials Company Limited",
      location: "Kibaha Misugusugu",
      logo: josekoLogo
    },
    {
      name: "Genemma Arts and Soul",
      location: "Makongo Juu",
      logo: genemmaLogo
    },
    {
      name: "Tripple J Investment",
      location: "Madale Njiapanda Mascout",
      logo: tripplejLogo
    },
    {
      name: "Unique Shopping Centre",
      location: "Mapinga Bagamoyo",
      logo: uniqueLogo
    },
    {
      name: "Techone Digital Limited",
      location: "Dar es Salaam",
      logo: techoneLogo
    },
    {
      name: "Superzamo Animal Feeds",
      location: "Mapinga Bunju Bagamoyo",
      logo: superzamoLogo
    },
    {
      name: "Lesha Pharmacy and Cosmetics",
      location: "Dar es Salaam",
      logo: leshaLogo
    }
  ];

  return (
    <section className="YcscPremiumSponsorsSection position-relative py-5">
      <div className="container py-5">
        
        {/* PREMIUM BRIEF HEADER */}
        <div className="row justify-content-center text-center mb-5">
          <div className="col-12 col-lg-8">
            <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
              <span className="sponsor-luxury-line"></span>
              <span className="sponsor-pre-title text-uppercase tracking-wider">WAKFU WA USHIRIKA</span>
              <span className="sponsor-luxury-line"></span>
            </div>
            <h2 className="sponsor-main-title fw-bold text-dark mb-3">
              Wadhamini Wetu Wakuu Waliowezesha <br />
              <span className="text-sponsor-gold">Tabasamu kwa Jamii</span>
            </h2>
            <p className="text-muted sponsor-editorial-p px-md-4">
              Wadhamini wetu wamekuwa nguzo muhimu sana katika kufanikisha harambee ya maandalizi ya 
              <strong> "Community Day"</strong> inayofanyika mwezi wa pili wa kila mwaka, harambee ambayo 
              huendeshwa kwa umahiri mkubwa wakati wa sherehe zetu za mwisho wa mwaka <strong>(End of the Year Party)</strong>.
            </p>
          </div>
        </div>

        {/* SPONSORS HIGH-END MARQUEE / GRID DISPLAY */}
        <div className="row g-4 justify-content-center">
          {sponsorList.map((sponsor, index) => (
            <div className="col-12 col-sm-6 col-md-4 col-xl-3" key={index}>
              <div className="premium-sponsor-card d-flex flex-column justify-content-between h-100 p-4 rounded-4 transition-all bg-white">
                
                {/* Logo Frame */}
                <div className="sponsor-logo-frame d-flex align-items-center justify-content-center rounded-3 p-3 mb-3">
                  <img 
                    src={sponsor.logo} 
                    alt={`${sponsor.name} Logo`} 
                    className="sponsor-img-fluid transition-all"
                  />
                </div>

                {/* Info Text Area */}
                <div className="sponsor-meta-area mt-2">
                  <h4 className="sponsor-company-name fw-bold text-dark mb-2">
                    {sponsor.name}
                  </h4>
                  
                  <div className="d-flex align-items-start gap-2 text-muted small mb-1">
                    <MdLocationOn size={16} className="text-sponsor-gold flex-shrink-0 mt-1" />
                    <span className="line-clamp-2">{sponsor.location}</span>
                  </div>

                  {sponsor.hasEmail && (
                    <div className="d-flex align-items-center gap-2 text-muted small mt-2 pt-2 border-top border-light">
                      <MdEmail size={14} className="text-primary-color" />
                      <a href={`mailto:${sponsor.contact}`} className="sponsor-email-link font-monospace">
                        {sponsor.contact}
                      </a>
                    </div>
                  )}
                </div>

                {/* Bottom Architectural Accent */}
                <div className="sponsor-card-interactive-footer pt-3 mt-3 d-flex align-items-center justify-content-between">
                  <span className="sponsor-badge-tag"><MdHandshake size={12} /> Partner</span>
                  <span className="sponsor-visit-indicator text-uppercase fw-bold font-monospace">
                    Visit <MdLanguage size={12} />
                  </span>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}